export enum DirectDebitTestHooks {
  Form = 'direct-debit-details-form',
  AccountName = 'direct-debit-account-name-text',
  AccountNumber = 'direct-debit-account-number',
  SortCode = 'direct-debit-sort-code',
  Iban = 'direct-debit-iban-text',
  PaymentDate = 'direct-debit-payment-date-select',
  AccountHolder = 'direct-debit-account-holder-checkbox',
}
